export const roleTypes = {
  admin: "Admin",
  recruiter: "Recruiter",
  hiringManager: "Hiring Manager",
};

export const REDIRECTION_LINKS = {
  "interviewCredits": "/interview-credits",
  "outreach": "/outreach",
  "outreachedJob": "/outreach/outreached-job",
  "talentPool": "/talent-pool",
}

export const CANDIDATE_STATUS_MAP = {
  "Applied": "Applied",
  "Pending": "Pending",
  "Interviewed": "Interviewed",
  "Shortlisted": "Shortlisted",
  "Hired": "Hired",
  "Rejected": "Rejected",
  "Incomplete": "Incomplete",
}

export const HEARD_ABOUT_US_CONTANTS = [
  { value: 'Campus campaign', label: 'Campus campaign' },
  { value: 'Company website', label: 'Company website' },
  { value: 'Employees referral', label: 'Employees referral' },
  { value: 'Naukri', label: 'Naukri' },
  { value: 'Indeed', label: 'Indeed' },
  { value: 'LinkedIn', label: 'LinkedIn' },
  { value: 'Recruitment agency', label: 'Recruitment agency' },
  { value: 'Northstarz', label: 'Northstarz' },
  { value: 'Company Initiated', label: 'Company Initiated' },
  { value: 'Others', label: 'Others' }
];

export const HEARD_ABOUT_US_MAPPER = {
  "Campus campaign": "Campus campaign",
  "Company website": "Company website",
  "Employees referral": "Employees referral",
  "Naukri": "Naukri",
  "Indeed": "Indeed",
  "LinkedIn": "LinkedIn",
  "Recruitment agency": "Recruitment agency",
  "Northstarz": "Northstarz",
  "Company Initiated": "Company Initiated",
  "Others": "Others"
}

export const SOURCE_TO_COLOR_MAPPER = {
  "Campus campaign": "#17A3A0",
  "Company website": "#E0726C",
  "Employees referral": "#f8bc6c",
  "Naukri": "#656565",
  "Indeed": "#C175D4",
  "LinkedIn": "#C1D685",
  "Recruitment agency": "#9D96E8",
  "Others": "#538EC9",
  "Northstarz": "#148EFF",
  "Company Initiated": "#0E8900",
  "undefined": "#038900",
}

export const HEARD_ABOUT_US_SMALL_MAPPER = {
  "Campus campaign": "Campus",
  "Company website": "Website",
  "Employees referral": "Referral",
  "Naukri": "Naukri",
  "Indeed": "Indeed",
  "LinkedIn": "LinkedIn",
  "Recruitment agency": "Agency",
  "Northstarz": "Northstarz",
  "Company Initiated": "Company",
  "Others": "Others"
}

export const OFFER_LETTER_CONSTANTS = {
  "candidate_name": "Candidate name",
  "candidate_first_name": "Candidate first name",
  "address_line_1": "Address line 1",
  "address_line_2": "Address line 2",
  "city": "City",
  "pin_code": "PIN Code",
  "state": "State",
  "job_title": "Job title",
  "department_name": "Department name",
  "grade": "Grade",
  "date_of_join": "Date of join",
  "date_of_offer_expiry": "Date of offer expiry",
  "signatory": "Signatory",
  "ctc": "CTC",
  "ctc_in_words": "CTC in words",
  "variable_pay": "Variable pay",
  "location": "Location",
  "company_name": "Company name",
  "pagebreak": "pagebreak",
  "offer_created_at": "Date",
  "salary_table": "Salary Computation",
  "email_id": "Email ID",
  "mob_no": "Mobile No",
  "ref_no": "Reference No",
  "year_now": "Financial Year",
  "controlling_officer": "Controlling Officer",
  "probation_period": "Probation period",
}

export const OFFER_LETTER_MAPPER = {
  "Candidate name": "candidate_name",
  "Candidate first name": "candidate_first_name",
  "Address line 1": "address_line_1",
  "Address line 2": "address_line_2",
  "City": "city",
  "PIN Code": "pin_code",
  "State": "state",
  "Job title": "job_title",
  "Department name": "department_name",
  "Grade": "grade",
  "Date of join": "date_of_join",
  "Date of offer expiry": "date_of_offer_expiry",
  "Signatory": "signatory",
  "CTC": "ctc",
  "CTC in words": "ctc_in_words",
  "Variable pay": "variable_pay",
  "Location": "location",
  "Company name": "company_name",
  "pagebreak": "pagebreak",
  "Date": "offer_created_at",
  "Salary Computation": "salary_table",
  "Email ID": "email_id",
  "Mobile No": "mob_no",
  "Reference No": "ref_no",
  "Financial Year": "year_now",
  "Controlling Officer": "controlling_officer",
  "Probation period": "probation_period"
}

export const CURRENCY_PREFIXES = ["INR", "USD", "AUD", "SGD", "GBP", "EUR", "AED"];
